import * as angular from 'angular';

import * as insertFilterModal from './insert-filter-modal';

const EVENT_NAMESPACE = 'insertfilter';

export default class InsertFilterModalTriggerController {
  onInsert: ($args: { $field: any }) => void;

  static $inject = ['$element', 'ModalService'];

  constructor(private $element: angular.IAugmentedJQuery, private Modal) {}

  $postLink = () => {
    this.$element.on(this.namespaceEvent('click'), this.handleClick.bind(this));
  };

  $onDestroy = () => {
    this.$element.off(this.namespaceEvent('click'));
  };

  namespaceEvent(eventName) {
    return [eventName, EVENT_NAMESPACE].join('.');
  }

  handleClick(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    this.openModal()
      .then(this.handleModalClose.bind(this))
      .catch(function () {});
  }

  /**
   * Open Modal
   *
   * @todo change return type to something more strict than Promise<any>
   * @returns {Promise<any>}
   */
  openModal(): Promise<any> {
    const { result } = insertFilterModal.spawn();

    return result;
  }

  /**
   *
   * @todo should a service be called or do we pass to {onInsert}?
   * @param $field
   */
  handleModalClose($field: any) {
    if (this.onInsert) {
      this.onInsert({ $field });
    }
  }
}
